import { BookOpenCheck } from "lucide-react";
import { runtimeConfig } from "../api";
import { DemoBanner } from "./DemoBanner";

export function RuntimeBanner() {
  if (runtimeConfig.contentMode === "demo") return <DemoBanner />;
  if (runtimeConfig.contentMode !== "non_release_source_drafts") return null;
  return (
    <div
      className="demo-banner"
      role="note"
      aria-label="来源草稿研发课堂说明"
    >
      <BookOpenCheck aria-hidden="true" />
      <strong>来源草稿研发课堂</strong>
      <span>
        使用甲种本原 PDF 对齐草稿和
        {runtimeConfig.sourceDraftTeacherMode === "live"
          ? "真实教师模型"
          : "确定性教师夹具"}
        ；尚未双人定稿，不形成正式学习证据
      </span>
    </div>
  );
}
